import { useWebSettingsModel } from '@entities/common';
import React from 'react';
import { xhr } from '@shared/config';
import { useAuthToken } from '@shared/hooks/index.ts';
import type { WebSettings } from '@shared/types/common';
import { webSettingsApi } from './api';

export const useLoadWebsettings = () => {
  const { setSettings } = useWebSettingsModel();
  const { token } = useAuthToken();

  const loadSavedSettings = () => {
    const favicon = document.getElementById('favicon-platform') as any;
    const storedSettings = localStorage.getItem('webSettings');

    if (favicon && storedSettings) {
      const webSettings: WebSettings = JSON.parse(storedSettings);
      favicon.href = `${window.location.origin}${webSettings.favicon}`;
      document.title = webSettings.resource_name ?? '';
    }
  };

  const loadSettings = () => {
    const controller = new AbortController();
    const getWebSettings = async () => {
      loadSavedSettings();

      try {
        const response = await xhr.get(webSettingsApi, { signal: controller.signal });

        if (!response.data) {
          throw response;
        }

        // localStorage.setItem('webSettings', JSON.stringify(response.data));
        setSettings(response.data);
        const favicon = document.getElementById('favicon-platform') as any;
        favicon.href = `${window.location.origin}${response.data.favicon}`;
        document.title = response.data.resource_name ?? '';
      } catch (error) {}
    };

    getWebSettings();

    return () => {
      controller.abort();
    };
  };

  React.useEffect(loadSettings, [token]);
};
